const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaArrowLeftFill0\"><g id=\"evaArrowLeftFill1\"><path id=\"evaArrowLeftFill2\" fill=\"currentColor\" d=\"M13.54 18a2.06 2.06 0 0 1-1.3-.46l-5.1-4.21a1.7 1.7 0 0 1 0-2.66l5.1-4.21a2.1 2.1 0 0 1 2.21-.26a1.76 1.76 0 0 1 1.05 1.59v8.42a1.76 1.76 0 0 1-1.05 1.59a2.23 2.23 0 0 1-.91.2Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
